import { GlBadge, GlIcon, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__, sprintf } from '~/locale';
import ApprovalsCountCe from '../../../../../../app/assets/javascripts/merge_requests/components/approval_count.vue?vue3';
import { TYPENAME_USER } from '~/graphql_shared/constants';
import { convertToGraphQLId } from '~/graphql_shared/utils';
export default {
    name: 'ApprovalCount',
    components: {
        GlBadge,
        GlIcon,
        ApprovalsCountCe
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        mergeRequest: {
            type: Object,
            required: true
        },
        fullText: {
            type: Boolean,
            required: false,
            default: false
        },
        /**
     * Renders a subtle icon and count instead of the badge, for dense lists where a
     * coloured pill would compete with the merge request title for attention.
     */ neutral: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        neutralText () {
            return sprintf(s__('Approvals|%{count} of %{total}'), {
                count: this.mergeRequest.approvalsRequired - this.mergeRequest.approvalsLeft,
                total: this.mergeRequest.approvalsRequired
            });
        },
        approvedByCurrentUser () {
            const userID = convertToGraphQLId(TYPENAME_USER, gon.current_user_id || '');
            return this.mergeRequest.approvedBy?.nodes.some((u)=>u.id === userID);
        },
        approvalText () {
            if (this.fullText) {
                if (this.mergeRequest.approved) {
                    return __('Approved');
                }
                return sprintf(__('%{approvals_given} of %{required} Approvals'), {
                    approvals_given: this.mergeRequest.approvalsRequired - this.mergeRequest.approvalsLeft,
                    required: this.mergeRequest.approvalsRequired
                });
            }
            return `${this.mergeRequest.approvalsRequired - this.mergeRequest.approvalsLeft}/${this.mergeRequest.approvalsRequired}`;
        },
        tooltipTitle () {
            return sprintf(this.approvedByCurrentUser ? __("Required approvals (%{approvals_given} of %{required} given, you've approved)") : __('Required approvals (%{approvals_given} of %{required} given)'), {
                approvals_given: this.mergeRequest.approvalsRequired - this.mergeRequest.approvalsLeft,
                required: this.mergeRequest.approvalsRequired
            });
        },
        badgeVariant () {
            return this.mergeRequest.approved ? 'success' : 'neutral';
        },
        badgeIcon () {
            if (this.mergeRequest.approved && this.approvedByCurrentUser) return 'approval-solid';
            if (this.mergeRequest.approved) return 'check-circle';
            return this.mergeRequest.approvalsRequired - this.mergeRequest.approvalsLeft > 0 ? 'check-circle-dashed' : 'dash-circle';
        }
    }
};
